
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/wealth-simulator",
      function () {
        return require("private-next-pages/tools/wealth-simulator.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/wealth-simulator"])
      });
    }
  